var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"UserAgreement"},[_vm._m(0),_c('enAgreement')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticStyle:{"width":"0.18rem","height":"0.31rem"}})])
}]

export { render, staticRenderFns }